import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import * as React from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";

export default function TeamMenu({
  data,
  styleProps,
  hoverProps,
  onChange,
  selectedTeam,
}) {
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            variant="outlined"
            disableRipple
            startIcon={
              <img
                src={allIcons.teamInactiveIcon}
                alt={"team-icon"}
                width={20}
              />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor={appcolors.black}
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            {...bindTrigger(popupState)}
            sx={{
              "& .MuiButton-endIcon": {
                borderLeft: "1px solid #ECF0F2",
              },
              border: "none",
              borderRadius: 0,
              padding: 0,
              color: "#0000008A",
              fontWeight: 400,
              width: "auto",
              height: "auto",
              ...styleProps,
              "&:hover": {
                color: "#0000008A",
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                ...hoverProps,
              },
            }}
          >
            {selectedTeam?.firstname ? selectedTeam?.firstname : "Team"}
          </Button>
          <Menu {...bindMenu(popupState)}>
            {data?.length > 0 && (
              <>
                {data?.map((item) => {
                  return (
                    <MenuItem
                      key={item?._id}
                      value={item?._id}
                      onClick={(e) => {
                        onChange(e, item._id);
                        popupState.close();
                      }}
                    >
                      {item.firstname + " " + item.lastname}
                    </MenuItem>
                  );
                })}
              </>
            )}
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
